import axios from "axios";

export const axiosProtected = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  // timeout: 30000, // 30 seconds timeout
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

export default axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  // timeout: 30000, // 30 seconds timeout
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
